import { doUpdateImageBanner } from '../../../actions/siteadmin/manageImageBanner';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {
  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;
  await dispatch(doUpdateImageBanner(values));
}

export default submit;
